import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useTheme } from '../contexts/ThemeContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import ResearchReportContent from './ResearchReportContent';
import ModalShell from './ModalShell';
import '../apps/ResearchReportsApp.css';

// Ensure ChartJS components are registered
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const ResearchReportModal = ({ isOpen, onClose, apirCode }) => {
  const { theme } = useTheme();
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen || !apirCode) return;

    setIsLoading(true);
    setError(null);
    setReportData(null);

    api.get(`/api/reports/fund/${apirCode}`)
      .then((response) => {
        setReportData(response.data);
      })
      .catch((err) => {
        console.error('Error fetching report:', err);
        setError('Failed to load report data');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [isOpen, apirCode]);

  const displayFundName = reportData?.fund_details?.fund_name;

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title={displayFundName ? `Research Report – ${displayFundName}` : 'Research Report'}
      maxWidth="1200px"
      bodyStyle={{ padding: '20px', background: '#f0f0f0' }}
    >
      {isLoading && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '200px', textAlign: 'center' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading report...</p>
        </div>
      )}
      {error && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '200px', textAlign: 'center' }}>
          <i className="bi bi-exclamation-triangle" style={{ fontSize: '3rem', color: '#ffc107' }}></i>
          <p>{error}</p>
        </div>
      )}
      {reportData && !isLoading && (
        <div className="research-reports-container" style={{ padding: 0 }}>
          <div className="report-wrapper">
            <div className="report-content">
              <ResearchReportContent
                reportData={reportData}
                displayFundName={displayFundName}
                theme={theme}
              />
            </div>
          </div>
        </div>
      )}
    </ModalShell>
  );
};

export default ResearchReportModal;
